import { FC, memo } from 'react';

import { Link } from 'application/providers/RouterProvider';

import { TEXTS } from '../texts';

interface DisabledPointHintProps {
  pageLink: string;
  onClick: () => void;
}

const DisabledPointHint: FC<DisabledPointHintProps> = ({ pageLink, onClick }) => (
  <>
    {`${TEXTS.CHOOSE_POINTS_DISABLED_HINT_DESCRIPTION} `}
    <Link
      onClick={onClick}
      to={pageLink}>
      {TEXTS.CHOOSE_POINTS_DISABLED_HINT_LINK}
    </Link>
  </>
);

export default memo(DisabledPointHint);
